var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaign-story"},[(_vm.campaign)?_c('app-preview-card',{attrs:{"size":"medium","width":"130","height":"200","background-image":_vm.campaignImage,"overlay-number":_vm.ranking,"overlay":_vm.campaign.name}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }